export default __webpack_public_path__ + "static/media/ipst.548096e7.svg";